import React, { FC, useEffect, useState } from "react";
import {
  QuestionConfigDetailDto,
  QuestionConfigTranslationDto,
} from "@green0meter/api-client";

import { StyledTextField } from "../../QuestionTypeEditor.styled";

import { Chip, Dropdown } from "@components/base";
import { useGetQuestionUnits } from "@api";
import { useQuestionEditorStore } from "@components/main/questions/QuestionEditor";
import { useUserStore } from "@store/user";

interface NumberInput {
  questionConfig: QuestionConfigDetailDto;
  setQuestionConfig: (questionConfig: QuestionConfigDetailDto) => void;
}

const NumberInput: FC<NumberInput> = ({ questionConfig, setQuestionConfig }) => {
  const { language } = useQuestionEditorStore();
  const { user } = useUserStore();
  const { units } = useGetQuestionUnits(user);
  const [translation, setTranslation] = useState<QuestionConfigTranslationDto>();

  useEffect(() => {
    if (units && questionConfig && !questionConfig.unit) {
      setQuestionConfig({
        ...questionConfig,
        unit: {
          id: units[0].id,
          name: units[0].name,
          abbreviation: units[0].abbreviation,
        },
      });
    }
  }, [units]);

  useEffect(() => {
    if (questionConfig) {
      const currentTranslation = questionConfig.translations.find(
        (translation) => translation.language === language,
      );

      setTranslation(currentTranslation);
    }
  }, [questionConfig, language]);

  return questionConfig ? (
    <StyledTextField
      value={translation?.placeholder || ""}
      placeholder="Placeholder"
      variant="filled"
      fullWidth
      slotProps={{
        input: {
          onChange: (e) =>
            setQuestionConfig({
              ...questionConfig,
              translations: questionConfig.translations.map((translation) =>
                translation.language === language
                  ? { ...translation, placeholder: e.target.value }
                  : translation,
              ),
            }),
          endAdornment: (
            <Dropdown
              button={{
                variant: "text",
                size: "small",
                title: <Chip label={questionConfig.unit?.abbreviation} />,
              }}
              options={
                units?.map((unit) => ({
                  id: unit.id,
                  title: <Chip label={unit.abbreviation} />,
                })) || []
              }
              onSelect={(option) => {
                const unit = units?.find((u) => u.id === option.id);

                if (unit) {
                  setQuestionConfig({
                    ...questionConfig,
                    unit: {
                      id: unit.id,
                      name: unit.name,
                      abbreviation: unit.abbreviation,
                    },
                  });
                }
              }}
            />
          ),
        },
      }}
    />
  ) : null;
};

export default NumberInput;
